// Connection stats content (F-CALL-6), redesigned as per-attendee cards with a
// quality badge instead of a bare table. Lives inside Host controls (host-only).
// Pull-based 1Hz polling ONLY while mounted — the host stats view unmounts it
// when they go back, so closed costs nothing.

import { AttendeeStats, formatBitrate } from '@brizina/call-engine';
import { memo, useEffect, useState } from 'react';

import { engine } from '../engine';
import { probeRender } from '../perf/renderProbe';
import { callStore } from '../store/callStore';

interface Row extends AttendeeStats {
  name: string;
  quality: string;
}

export const ConnectionStats = memo(function ConnectionStats() {
  probeRender('ConnectionStats');
  const [rows, setRows] = useState<Row[]>([]);

  useEffect(() => {
    const collect = () => {
      const s = callStore.getState();
      const next: Row[] = [];
      for (const id of s.order) {
        const a = s.attendees[id];
        const stats = engine.readStats(id);
        if (a && stats) next.push({ ...stats, name: a.name, quality: a.quality });
      }
      setRows(next);
    };
    collect();
    const timer = setInterval(collect, 1000);
    return () => clearInterval(timer);
  }, []);

  if (rows.length === 0) {
    return <p className="bz-mt-empty">Gathering connection data…</p>;
  }

  return (
    <div className="bz-cstats">
      {rows.map((r) => (
        <div key={r.identity} className="bz-cstat">
          <div className="bz-cstat-top">
            <span className="bz-cstat-name">{r.name}</span>
            <span className={`bz-cstat-q bz-cstat-q-${r.quality}`}>{r.quality}</span>
          </div>
          <div className="bz-cstat-grid">
            <div className="bz-cstat-cell">
              <span className="bz-cstat-k">Video</span>
              <span className="bz-cstat-v">{formatBitrate(r.videoBitrate)}</span>
            </div>
            <div className="bz-cstat-cell">
              <span className="bz-cstat-k">Audio</span>
              <span className="bz-cstat-v">{formatBitrate(r.audioBitrate)}</span>
            </div>
            <div className="bz-cstat-cell">
              <span className="bz-cstat-k">Resolution</span>
              <span className="bz-cstat-v">{r.width > 0 ? `${r.width}×${r.height}` : '—'}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
});
